module.exports = __webpack_public_path__ + "static/img/tiandian.ead7fb99.png";